import { isGlobalDebugEnabled } from '../../../debug/debugUtil';

const tableInstances = {};

/**
 * Singleton object for managing table instances.
 *
 * This can be used by code external to the Table component to alter table instances,
 * e.g. table toolbar operations, undo/redo, etc.
 */
const TableInstanceApiSingleton = {
    add: (elementId, instance) => {
        tableInstances[elementId] = instance;
    },
    remove: (elementId) => {
        delete tableInstances[elementId];
    },
    get: (elementId) => {
        return tableInstances[elementId];
    },
};

if (isGlobalDebugEnabled()) {
    window.getHotTableComponent = TableInstanceApiSingleton.get;
    window.getHotInstance = (elementId) => TableInstanceApiSingleton.get(elementId)?.hotTableInstanceRef?.current;
}

export default TableInstanceApiSingleton;
